import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-algorithm-card',
  imports: [],
  templateUrl: './rid-algorithm-card.html',
})
export class RidAlgorithmCard {
  showDubbelzetter = input<boolean>(false);
}
